import {CommonModule} from '@angular/common';
import {Component, Input} from '@angular/core';
import {MatTooltipModule, TooltipPosition} from '@angular/material/tooltip';

@Component({
  selector: 'app-disabled-button-reason',
  standalone: true,
  imports: [CommonModule, MatTooltipModule],
  templateUrl: './disabled-button-reason.component.html',
  styleUrls: ['./disabled-button-reason.component.scss']
})
export class DisabledButtonReasonComponent {
  @Input() disabled = false;
  @Input() reason = '';
  @Input() position: TooltipPosition = 'above';

  get hasReason(): boolean {
    return this.disabled && this.reason.trim().length > 0;
  }
}
